// extracted by mini-css-extract-plugin
export var active = "_a6-d";
export var blink = "_a6-e";
export var container = "_a6-5";
export var controls = "_a6-0";
export var controlsRight = "_a6-1";
export var fakeCursor = "_a6-c";
export var hidden = "_a6-b";
export var quillContainerSmall = "_a6-7";
export var quillEditor = "_a6-6";
export var quillEditorSmall = "_a6-8";
export var quillFormatButtons = "_a6-a";
export var quillToolbar = "_a6-9";
export var removePadding = "_a6-2";
export var state = "_a6-3";
export var stateTitle = "_a6-4";